import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import Button from "@material-ui/core/Button";
import Toolbar from "@mui/material/Toolbar";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import TableContainer from "@mui/material/TableContainer";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { downloadExcel } from "react-export-table-to-excel";
import { CSVLink, CSVDownload } from "react-csv";
import Chip from "@mui/material/Chip";
import EditIcon from '@mui/icons-material/Edit';
import CircularProgress from '@mui/material/CircularProgress';
import swal from "sweetalert";
// Modal Dialog
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';

const token = localStorage.getItem("access_token");
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const drawerWidth = 240;
var bgColors = {
    Default: "#81b71a",
    Blue: "#00B1E1",
    Cyan: "#37BC9B",
    Green: "#8CC152",
    Red: "#9e0000",
    Yellow: "#F6BB42",
};

const bulanlist = [
    {
        value: "1",
        label: "Januari",
    },
    {
        value: "2",
        label: "Februari",
    },
    {
        value: "3",
        label: "Maret",
    },
    {
        value: "4",
        label: "April",
    },
    {
        value: "5",
        label: "Mei",
    },
    {
        value: "6",
        label: "Juni",
    },
    {
        value: "7",
        label: "July",
    },
    {
        value: "8",
        label: "Agustus",
    },
    {
        value: "9",
        label: "September",
    },
    {
        value: "10",
        label: "Oktober",
    },
    {
        value: "11",
        label: "November",
    },
    {
        value: "12",
        label: "Desember",
    },
];

const tahunlist = [
    {
        value: "2018",
        label: "2018",
    },
    {
        value: "2019",
        label: "2019",
    },
    {
        value: "2020",
        label: "2020",
    },
    {
        value: "2021",
        label: "2021",
    },
    {
        value: "2022",
        label: "2022",
    },
    {
        value: "2023",
        label: "2023",
    },
];

const useStyles = makeStyles((theme) => ({
    headerimage: {
        width: theme.spacing(10),
        height: theme.spacing(5),
    },
    thead: {
        backgroundColors: bgColors.Cyan,
    },
    btn: {
        marginTop: theme.spacing(2),
    },
    btnexport: {
        float: "right",
        marginBottom: theme.spacing(1),
        backgroundColors: bgColors.Green,
    },
}));

function ListKendaraan(props) {
    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth();
    const [bulan, setBulan] = React.useState(month+1);
    const [tahun, setTahun] = React.useState(year);
    const [isLoading, setLoading] = React.useState(true);
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(25);
    const [open, setOpen] = React.useState(false);
    const handleClose = () => setOpen(false);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [refreshDt, setRefresh] = useState();
    const [loadingSet, setLoadingData] = useState(false);

    const handleClickOpen = (event) => {
        console.log(event);
        setOpen(true);
        setInputs(values => ({...values, ["id"]: event.id}));
    }

    const handleChange = (event) => {
        setBulan(event.target.value);
    };
    const handleChange2 = (event) => {
        setTahun(event.target.value);
    };

    const handleClickServiceC1 = (event) => {
        updateService("c1", event.id);
    };
    const handleClickServiceC10 = (event) => {
        updateService("c10", event.id);
    };
    const handleClickServiceC20 = (event) => {
        updateService("c20", event.id);
    };
    const handleClickServiceC30 = (event) => {
        updateService("c30", event.id);
    };
    const handleClickServiceC40 = (event) => {
        updateService("c40", event.id);
    };
    const handleClickServiceC50 = (event) => {
        updateService("c50", event.id);
    };
    const handleClickServiceC60 = (event) => {
        updateService("c60", event.id);
    };
    const handleClickServiceC70 = (event) => {
        updateService("c70", event.id);
    };
    const handleClickServiceC80 = (event) => {
        updateService("c80", event.id);
    };

    function updateService(type, id) {
        axios.post(`https://api.aims.wijayatoyota.co.id/api/area/sa/cekservice/process`, {
            id: id,
            tipe: type,
        })
        .then((response) => {
            swal("Success", 'Data Berhasil disimpan!', "success", {
                buttons: false,
                timer: 2000,
            });
            setRefresh(response);
        });
    }

    const queryOptions = React.useMemo(
        () => ({
            page,
            pageSize,
        }),
        [page, pageSize]
    );

    // API List Data Prospek
    const [dataProspek, setDataProspek] = useState([]);
    const [dataProspek2, setDataProspek2] = useState([]);
    const [allProspek, setAllProspek] = useState([]);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        const getData = async () => {
            setLoadingData(true);
            const url = `https://api.aims.wijayatoyota.co.id/api/area/sa/cekservice/listkendaraan?page=${page}&size=${pageSize}`;
            try {
                const response = await axios.get(url);
                // if (response.statusText === "") {
                    setDataProspek(response.data.data);
                    setDataProspek2(response.data);
                    setLoading(false);
                    setLoadingData(false);
                // } else {
                //     throw new Error("Request failed");
                // }
            } catch (error) {
                console.log(error);
            }
        };
        getData();
    }, [page, pageSize, refreshDt]);

    const [rowCountState, setRowCountState] = React.useState(
        dataProspek2?.all || 0
    );

    React.useEffect(() => {
        setRowCountState((prevRowCountState) =>
            dataProspek2?.all !== undefined
                ? dataProspek2?.all
                : prevRowCountState
        );
    }, [dataProspek2?.all, setRowCountState]);

    const [inputs, setInputs] = useState([]);
    const handleChangeInput = (event) => {
        setInputs(values => ({...values, [event.target.name]: event.target.value}));
    }

    const columns = [
        { field: "nama_sales", headerName: "Sales", minWidth: 200 },
        { field: "nama_stnk", headerName: "Nama STNK", minWidth: 200 },
        { field: "tgl_do", headerName: "Tanggal DO", minWidth: 200 },
        { field: "no_rangka", headerName: "No Rangka", minWidth: 200 },
        { field: "Service 1K", renderCell: (cellValues) => {
            return cellValues.row.c1 == null ? (
                <Button
                    size="small"
                    variant="outlined"
                    style={{ background: "#26de81", border: "1px solid #26de81", color: "white" }}
                    startIcon={<EditIcon />}
                    onClick={(event) => {
                        handleClickServiceC1(cellValues.row);
                    } }
                >
                    Process
                </Button>
            ) : (
                <Chip label="Sudah"></Chip>
            );
        }, minWidth: 200, align: "center" },
        { field: "Service 10K", renderCell: (cellValues) => {
            return cellValues.row.c10 == null ? (
                <Button
                    size="small"
                    variant="outlined"
                    style={{ background: "#26de81", border: "1px solid #26de81", color: "white" }}
                    startIcon={<EditIcon />}
                    onClick={(event) => {
                        handleClickServiceC10(cellValues.row);
                    } }
                >
                    Process
                </Button>
            ) : (
                <Chip label="Sudah"></Chip>
            );
        }, minWidth: 200, align: "center" },
        { field: "Service 20K", renderCell: (cellValues) => {
            return cellValues.row.c20 == null ? (
                <Button
                    size="small"
                    variant="outlined"
                    style={{ background: "#26de81", border: "1px solid #26de81", color: "white" }}
                    startIcon={<EditIcon />}
                    onClick={(event) => {
                        handleClickServiceC20(cellValues.row);
                    } }
                >
                    Process
                </Button>
            ) : (
                <Chip label="Sudah"></Chip>
            );
        }, minWidth: 200, align: "center" },
        { field: "Service 30K", renderCell: (cellValues) => {
            return cellValues.row.c30 == null ? (
                <Button
                    size="small"
                    variant="outlined"
                    style={{ background: "#26de81", border: "1px solid #26de81", color: "white" }}
                    startIcon={<EditIcon />}
                    onClick={(event) => {
                        handleClickServiceC30(cellValues.row);
                    } }
                >
                    Process
                </Button>
            ) : (
                <Chip label="Sudah"></Chip>
            );
        }, minWidth: 200, align: "center" },
        { field: "Service 40K", renderCell: (cellValues) => {
            return cellValues.row.c40 == null ? (
                <Button
                    size="small"
                    variant="outlined"
                    style={{ background: "#26de81", border: "1px solid #26de81", color: "white" }}
                    startIcon={<EditIcon />}
                    onClick={(event) => {
                        handleClickServiceC40(cellValues.row);
                    } }
                >
                    Process
                </Button>
            ) : (
                <Chip label="Sudah"></Chip>
            );
        }, minWidth: 200, align: "center" },
        { field: "Service 50K", renderCell: (cellValues) => {
            return cellValues.row.c50 == null ? (
                <Button
                    size="small"
                    variant="outlined"
                    style={{ background: "#26de81", border: "1px solid #26de81", color: "white" }}
                    startIcon={<EditIcon />}
                    onClick={(event) => {
                        handleClickServiceC50(cellValues.row);
                    } }
                >
                    Process
                </Button>
            ) : (
                <Chip label="Sudah"></Chip>
            );
        }, minWidth: 200, align: "center" },
        { field: "Service 60K", renderCell: (cellValues) => {
            return cellValues.row.c60 == null ? (
                <Button
                    size="small"
                    variant="outlined"
                    style={{ background: "#26de81", border: "1px solid #26de81", color: "white" }}
                    startIcon={<EditIcon />}
                    onClick={(event) => {
                        handleClickServiceC60(cellValues.row);
                    } }
                >
                    Process
                </Button>
            ) : (
                <Chip label="Sudah"></Chip>
            );
        }, minWidth: 200, align: "center" },
        { field: "Service 70K", renderCell: (cellValues) => {
            return cellValues.row.c70 == null ? (
                <Button
                    size="small"
                    variant="outlined"
                    style={{ background: "#26de81", border: "1px solid #26de81", color: "white" }}
                    startIcon={<EditIcon />}
                    onClick={(event) => {
                        handleClickServiceC70(cellValues.row);
                    } }
                >
                    Process
                </Button>
            ) : (
                <Chip label="Sudah"></Chip>
            );
        }, minWidth: 200, align: "center" },
        { field: "Service 80K", renderCell: (cellValues) => {
            return cellValues.row.c80 == null ? (
                <Button
                    size="small"
                    variant="outlined"
                    style={{ background: "#26de81", border: "1px solid #26de81", color: "white" }}
                    startIcon={<EditIcon />}
                    onClick={(event) => {
                        handleClickServiceC80(cellValues.row);
                    } }
                >
                    Process
                </Button>
            ) : (
                <Chip label="Sudah"></Chip>
            );
        }, minWidth: 200, align: "center" },
    ];

    const [loadButton, setLoadButton] = React.useState(false);

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                p: 3,
                width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
        >
            <Toolbar />
            <Typography>
                <b>List Data</b>
            </Typography>{" "}
            <br />
            <Box
                component="form"
                sx={{
                    "& .MuiTextField-root": { m: 1, width: "25ch" },
                }}
                noValidate
                autoComplete="off"
            >
                <div>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="Bulan"
                        value={bulan}
                        onChange={handleChange}
                        helperText="Pilih Bulan"
                    >
                        {bulanlist.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        id="outlined-select-currency-native"
                        select
                        label="Tahun"
                        value={tahun}
                        onChange={handleChange2}
                        SelectProps={{
                            native: true,
                        }}
                        helperText="Pilih Tahun"
                    >
                        {tahunlist.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </TextField>
                </div>

            </Box>
            <br></br>
            <Box style={{ width: "100%" }}>
                {loadingSet === true ? 
                    // <center><CircularProgress size="1.2rem" color="inherit" /></center>
                    <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
                        <LinearProgress />
                    </Stack>
                :  
                    ""
                }
            </Box>
            <TableContainer style={{ height: 500, width: "100%" }}>
                <DataGrid
                    rows={dataProspek}
                    rowCount={rowCountState}
                    loading={isLoading}
                    components={{ Toolbar: GridToolbar }}
                    rowsPerPageOptions={[25, 50, 100]}
                    pagination
                    page={page}
                    pageSize={pageSize}
                    paginationMode="server"
                    onPageChange={(newPage) => setPage(newPage)}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    columns={columns}
                />
            </TableContainer>
        </Box>
    );
}

export default ListKendaraan;
